var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 124,
    viewBox: "0 0 128 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: 9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M61.3907 121.474C94.5921 121.474 121.509 94.5568 121.509 61.2368C121.509 27.9168 94.4735 1 61.3907 1C28.1893 1 1.27246 27.9168 1.27246 61.2368C1.27246 94.5568 28.1893 121.474 61.3907 121.474Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M78.8224 29.2204L96.9646 94.4374C97.5575 96.6904 96.2532 98.9433 94.0002 99.5362L30.0875 116.493C27.8346 117.086 25.5816 115.781 24.9888 113.528L2.69639 29.339C2.10351 27.0861 3.40785 24.8331 5.6608 24.2402L51.9056 12.0269L78.8224 29.2204Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M77.874 70.485L43.3683 79.6154L39.5738 80.564L28.0719 83.647C27.5976 83.7656 27.2419 84.3584 27.4791 84.9513C27.5976 85.5442 28.1905 85.8999 28.6648 85.7814L40.1667 82.6984L43.9612 81.7498L78.4669 72.6194C78.9412 72.5008 79.2969 71.9079 79.0598 71.315C78.9412 70.7222 78.3483 70.3664 77.874 70.485Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M75.6189 62.4221L62.8127 65.7423L58.4253 66.928L26.054 75.5841C25.5797 75.7027 25.224 76.2955 25.4611 76.8884C25.5797 77.4813 26.1726 77.837 26.6469 77.7185L59.1368 69.0624L63.5241 67.8766L76.3304 64.5565C76.8047 64.4379 77.1604 63.845 76.9233 63.2521C76.6861 62.7778 76.0932 62.3035 75.6189 62.4221Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M73.7246 54.2403L70.4045 55.0703L67.0844 55.9003L23.804 67.4022C23.3297 67.5208 22.974 68.1137 23.2111 68.7066C23.3297 69.2995 23.9226 69.6552 24.3969 69.5366L67.6772 58.0347L71.3531 57.0861L74.3175 56.2561C74.7918 56.1375 75.1476 55.5446 74.9104 54.9517C74.7918 54.4774 74.3175 54.1217 73.7246 54.2403Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M53.6832 96.2162L51.3117 96.8091C50.8374 96.9276 50.2445 96.5719 50.1259 95.979C50.0073 95.3861 50.2445 94.7933 50.7188 94.6747L53.0903 94.0818C53.5646 93.9632 54.1575 94.319 54.2761 94.9118C54.3947 95.6233 54.1575 96.0976 53.6832 96.2162Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M46.4488 98.1135L32.8125 101.671C32.3382 101.789 31.7454 101.434 31.6268 100.841C31.5082 100.248 31.7454 99.655 32.2197 99.5364L45.8559 95.9791C46.3302 95.8606 46.9231 96.2163 47.0417 96.8092C47.2789 97.4021 47.0417 97.9949 46.4488 98.1135Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M72.0624 46.0587L61.272 48.9045L58.6633 49.616L21.786 59.3393C21.3117 59.4578 20.956 60.0507 21.1932 60.6436C21.3117 61.2365 21.9046 61.5922 22.3789 61.4736L59.1376 51.869L61.7463 51.1575L72.4182 48.3117C73.011 48.1931 73.2482 47.6002 73.1296 46.8887C73.1296 46.4144 72.5367 45.9401 72.0624 46.0587Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M46.5696 28.1533L15.9769 36.2165C15.2654 36.4536 14.554 35.9793 14.3168 35.2679C14.0797 34.5564 14.554 33.8449 15.2654 33.6078L45.8581 25.5446C46.5696 25.3074 47.2811 25.7818 47.5182 26.4932C47.7554 27.2047 47.2811 27.9161 46.5696 28.1533Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M29.7316 40.4856L17.9925 43.5685C17.2811 43.8057 16.5696 43.3314 16.3324 42.6199C16.0953 41.9085 16.5696 41.197 17.2811 40.9599L28.9015 37.8769C29.613 37.6397 30.3245 38.114 30.5616 38.8255C30.7988 39.5369 30.3245 40.2484 29.7316 40.4856Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M51.905 12.027L56.6481 30.0506C57.3595 32.5407 60.0868 34.0822 62.5769 33.3707L78.8219 29.2206",
    fill: "#D6DCE8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M126.727 47.6003L115.818 114.477C115.463 116.73 113.21 118.272 110.957 117.798L45.9769 106.414C43.724 106.059 42.1825 103.806 42.5382 101.553L57.5974 15.8219C57.9532 13.5689 60.2061 12.0274 62.4591 12.5017L109.652 20.8021L126.727 47.6003Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M108.584 84.7147L73.4852 78.5488L69.6908 77.8373L57.9517 75.8215C57.4774 75.7029 56.8846 76.1772 56.8846 76.7701C56.766 77.363 57.1217 77.9559 57.596 78.0745L69.3351 80.0903L73.1295 80.8017L108.228 86.9677C108.702 87.0863 109.295 86.612 109.295 86.0191C109.414 85.4262 109.177 84.8333 108.584 84.7147Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M110.008 76.533L96.9641 74.28L92.5768 73.45L59.494 67.6398C59.0197 67.5212 58.4268 67.9955 58.4268 68.5884C58.3082 69.1812 58.6639 69.7741 59.1382 69.8927L92.2211 75.7029L96.6084 76.533L109.652 78.7859C110.126 78.9045 110.719 78.4302 110.719 77.8373C110.838 77.2444 110.482 76.6516 110.008 76.533Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M111.668 68.2329L108.229 67.64L104.79 67.0472L60.6799 59.3397C60.2056 59.2211 59.6127 59.6954 59.6127 60.2883C59.4941 60.8812 59.8499 61.4741 60.3242 61.5927L104.435 69.3001L108.229 70.0116L111.193 70.4859C111.668 70.6045 112.261 70.1302 112.261 69.5373C112.498 68.9444 112.261 68.3515 111.668 68.2329Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M75.8582 97.9951L73.4866 97.6394C73.0123 97.5208 72.6566 96.928 72.7752 96.3351C72.8938 95.7422 73.3681 95.2679 73.8424 95.3865L76.2139 95.7422C76.6882 95.8608 77.0439 96.4536 76.9254 97.0465C76.8068 97.758 76.3325 97.9951 75.8582 97.9951Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M68.6264 96.691L54.753 94.3195C54.2787 94.2009 53.923 93.608 54.0415 93.0151C54.1601 92.4222 54.6344 91.9479 55.1087 92.0665L68.9822 94.438C69.4565 94.5566 69.8122 95.1495 69.6936 95.7424C69.575 96.4538 69.1007 96.8096 68.6264 96.691Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M113.568 60.1695L102.54 58.2723L99.8132 57.798L62.2244 51.1577C61.7501 51.0391 61.1573 51.5134 61.1573 52.1063C61.0387 52.6992 61.3944 53.2921 61.8687 53.4106L99.4574 60.0509L102.185 60.5252L113.094 62.4225C113.687 62.541 114.161 62.0667 114.279 61.4738C114.398 60.881 114.042 60.2881 113.568 60.1695Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M98.0317 33.253L66.8461 27.7985C66.1346 27.6799 65.6603 26.9684 65.7789 26.257C65.8975 25.5455 66.6089 25.0712 67.3204 25.1898L98.506 30.6443C99.2174 30.7629 99.6917 31.4743 99.5732 32.1858C99.4546 32.7787 98.7431 33.3716 98.0317 33.253Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M77.5192 37.2839L65.543 35.1495C64.8315 35.031 64.3572 34.3195 64.4758 33.6081C64.5944 32.8966 65.3058 32.4223 66.0173 32.5409L77.8749 34.6752C78.5864 34.7938 79.0607 35.5053 78.9421 36.2167C78.8235 36.9282 78.1121 37.4025 77.5192 37.2839Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M109.533 20.802L106.331 39.1813C105.857 41.79 107.754 44.2801 110.363 44.7544L126.726 47.6003",
    fill: "#D6DCE8"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M82.0242 108.193C96.628 108.193 108.467 96.3541 108.467 81.7503C108.467 67.1465 96.628 55.3077 82.0242 55.3077C67.4204 55.3077 55.5817 67.1465 55.5817 81.7503C55.5817 96.3541 67.4204 108.193 82.0242 108.193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M120.371 122.588C119.345 122.588 118.319 122.178 117.498 121.254L100.357 104.113L99.7411 104.524C94.1987 108.629 87.7324 110.785 81.1636 110.785C73.2604 110.785 65.3572 107.603 59.5068 102.061C53.3485 96.2102 49.9614 88.3071 49.9614 79.6854C49.9614 62.5448 63.9203 48.5859 81.0609 48.5859C92.7617 48.5859 103.026 54.7443 108.568 65.2134C114.008 75.5799 113.289 87.6912 106.618 97.4419L106.207 98.0577L123.451 115.301C125.195 117.046 124.785 118.791 124.477 119.714C123.656 121.357 122.014 122.588 120.371 122.588ZM81.0609 57.1049C68.539 57.1049 58.4804 67.2662 58.4804 79.6854C58.4804 93.8495 70.0786 102.369 81.3688 102.369C88.2456 102.369 94.5066 99.2894 98.92 93.7469C104.36 86.9728 105.284 77.8379 101.486 69.9348C97.5857 62.0316 89.7852 57.1049 81.0609 57.1049Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M79.5349 86.0191C79.4163 85.5448 79.4163 85.0705 79.4163 84.4776C79.4163 82.4618 80.2463 80.6832 82.3807 79.1417L84.1593 77.8374C85.2265 77.0073 85.7008 76.0587 85.7008 74.8729C85.7008 73.2129 84.5151 71.5528 82.025 71.5528C79.4163 71.5528 78.2305 73.6872 78.2305 75.703C78.2305 76.1773 78.2305 76.533 78.3491 76.8887L73.606 76.7702C73.4875 76.2959 73.3689 75.703 73.3689 75.1101C73.3689 71.0785 76.3333 67.2841 81.9064 67.2841C87.5981 67.2841 90.681 70.9599 90.681 74.6358C90.681 77.6002 89.1396 79.616 87.0052 81.1575L85.4637 82.2247C84.1593 83.1733 83.4479 84.3591 83.4479 85.782V86.0191H79.5349ZM81.5507 88.3907C83.2107 88.3907 84.5151 89.695 84.5151 91.3551C84.5151 93.0151 83.2107 94.3195 81.5507 94.3195C79.8906 94.3195 78.5863 93.0151 78.5863 91.3551C78.7048 89.8136 79.8906 88.3907 81.5507 88.3907Z",
    fill: "#B2C0D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.644f97213d43fef7c7b16e868fabe15b.svg";
export { ForwardRef as ReactComponent };